import { MonoTypeOperatorFunction, OperatorFunction, retry, RetryConfig, timer } from 'rxjs'
import { map } from 'rxjs/operators'

// Retry with linear backoff based on attempt number.
// Example: attempt# * backoffMs → 1*250, 2*250, 3*250, ...
export function retryWithBackoff<T>(maxRetry: number, backoffMs: number): MonoTypeOperatorFunction<T> {
  const cfg: RetryConfig = {
    count: maxRetry,
    delay: (_err, retryCount) => timer(retryCount * backoffMs),
  }
  return retry(cfg) as MonoTypeOperatorFunction<T>
}

// Map raw API responses to domain models using a simple selector function.
export function mapApiResponse<TIn, T>(selector: (v: TIn) => T): OperatorFunction<TIn, T> {
  return source$ => source$.pipe(map(selector))
}
